<template>
  <div class="wh-block">
    <h2 class="uk-margin-bottom">Анкета</h2>
    <p class="uk-text-center uk-margin-bottom">Добро пожаловать в Genius School. Перед началом занятий,<br>заполните, пожалуйста небольшую анкету.
    </p>
    <div class="stepform">
      <Stepform />
    </div>
  </div>
</template>

<script>
import Stepform from './Stepform';
import { mapGetters } from 'vuex'

export default {
  name: "first-anketa",
  components: {
    Stepform
  },
  props: {
    item: ''
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  }
}
</script>